import { initialiseCarousel } from "./_helpers";
import { Swiper, Navigation, Controller } from "swiper";
import { mediaBreakpoints } from "../utils";
import { getElement, getElements } from "./../utils/functional";
import "swiper/swiper.scss";

export default function init({ el, context }) {
  const moduleClassName = el.dataset.moduleClassName;
  const swiperContainer = el.getElementsByClassName(
    `${moduleClassName}_Carousel`
  )[0];
  const swiperNext = el.getElementsByClassName(`${moduleClassName}_Next`)[0];
  const swiperPrevious = el.getElementsByClassName(
    `${moduleClassName}_Previous`
  )[0];

  const slideClass = `${moduleClassName}_Slide`;

  window.addEventListener("resize", makeCarousel() );

  makeCarousel();

  function makeCarousel() {
    var swiperInstance = initialiseCarousel(swiperContainer, {
      spaceBetween: 0,
      centeredSlides: false,
      slideClass: slideClass,
      slidesPerView: 1,
      preloadImages: true,
      watchSlidesProgress: false,
      setWrapperSize: false,
      watchOverflow: true,
      lazy: false,
      loop: false,
      navigation: {
        nextEl: swiperNext,
        prevEl: swiperPrevious,
        disabledClass: "product-images__navigation__disabled",
      },
    });
    setTimeout(function() {
      swiperInstance.update();
    }, 2000);
  }
}
